import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
} from '@angular/core';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { map, pluck } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProductListFascade } from '../../fascades/product-list.fascade';

@Component({
  selector: 'orderform-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderSummaryComponent {
  orderSummary$ = this._orderformFascade.order$.pipe(
    map((order) => order.order_summary)
  );

  isVatShown$: Observable<boolean> =
    this._orderformFascade.globalSettings$.pipe(pluck('is_vat_shown'));
  isVatHintMandatory$: Observable<boolean> =
    this._orderformFascade.globalSettings$.pipe(pluck('is_vat_hint_mandatory'));
  havePlainPriceView$ = this._productListFascade.settings$.pipe(
    pluck('have_plain_price_view')
  );
  footerInfoDialogVisible = false;

  public showDiscountOnSummary$ = this._orderformFascade.order$.pipe(
    map(
      (order) => order.order.discount_display_position.indexOf('summary') >= 0
    )
  );

  productsLength$ = this._productListFascade.cartProductList$.pipe(
    map((list) => list.length)
  );

  constructor(
    private _orderformFascade: OrderformFascade,
    private _productListFascade: ProductListFascade
  ) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const node = event.target as HTMLAnchorElement;
    if (node.tagName === 'A' && node.className.indexOf('clickable') >= 0) {
      event.preventDefault();
      this.footerInfoDialogVisible = true;
    }
  }
}
